export const LOAD_DISTANCES = 'MANAGE_TEAM_LOAD_DISTANCES';
export const MANAGE_TEAM_RACE = 'MANAGE_TEAM_RACE';
export const PATCH_TEAM_NAME = 'PATCH_TEAM_NAME';
export const ADD_TEAM_MEMBER = 'ADD_TEAM_MEMBER';
export const EDIT_TEAM_MEMBER = 'ADD_TEAM_MEMBER';
export const RESEND_INVITATION = 'RESEND_INVITATION';
